import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

type IndexParams = {
  json_params: string;
  paging_params: {
    limit: PaginationLimit;
    search_after?: (string | number)[];
    reverse_sort: boolean;
  };
  sort_params: {
    field: string;
    order: Order;
  };
};

export const index = async ({ json_params, ...params }: IndexParams) =>
  apiClient.get(`/opportunities?json_params=${json_params}`, { params });
